import { render } from "./CustomerList.vue?vue&type=template&id=58b17e3a"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"

import "./CustomerList.vue?vue&type=style&index=0&id=58b17e3a&lang=css"
script.render = render

export default script